<template>
  <RequestsReceivedWebReportPage mode="admin" />
</template>

<script>
import RequestsReceivedWebReportPage from "@/components/Reports/RequestsReceivedWebReport/RequestsReceivedWebReportPage.vue";

export default {
  name: "RequestsReceivedWebReport",
  components: { RequestsReceivedWebReportPage },
};
</script>
